import { NgxSpinnerService } from 'ngx-spinner';
import { SpinnerType } from '../enums';

export  class CustomSpinnerService {
  constructor(private spinner: NgxSpinnerService) { }

   showSpinner(spinnerNameType: SpinnerType) {
    this.spinner.show(spinnerNameType);

  
  }

  hideSpinner(spinnerNameType: SpinnerType):void {
    this.spinner.hide(spinnerNameType);
  }
}

